<template>
  <v-container>
    <v-row
      v-show="prospect.id"
      dense align="center"
      justify="center"
    >
      <v-col>
        <span class="font-weight-bold">{{ prospect.name }}</span>
        {{ ` ${prospect.fullName} (ID: ${prospect.id})` }}
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-row
          v-if="prospectHeadBars.length"
        >
          <v-col
            v-for="(bar, index) in prospectHeadBars"
            :cols="Math.floor(12/prospectHeadBars.length)"
            :key="index"
          >
            <GreyBarWithTitleAndValue
              :title = bar.title
              :value = bar.value
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="6"
          >
            <GoogleMapMarkers
              :items="geotagsOnMap"
              :isVisible="true"
            />
          </v-col>
          <v-col
            :cols="6"
          >
            Priority Destination Coverage
            <ProspectRouteExpandableTable
              :routes="prospectRoutes"
              :route-map-categories="routeMapCategories"
              :prospect-name="prospect.name"
              :geotags="geotagsTotal"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="4"
          >
            <SimpleList
              label="Reviews"
              :emphasized-text="prospectContent.reviewsTotalAmount"
              :main-list="prospectContent.providerRating"
            />
          </v-col>
          <v-col
            :cols="4"
          >
            <SimpleList
              label="Hashtags"
              :emphasized-text="prospectContent.poiHashtagsTotalAmount"
              :main-list="prospectContent.hashtagRating"
            />
          </v-col>
          <v-col
            :cols="4"
          >
            <SimpleList
              label="Guides"
              :emphasized-text="prospectContent.geotagHashtagsTotalAmount"
              :main-list="prospectContent.hashtagGeotagRating"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GoogleMapMarkers from '../components/GoogleMapMarkers.vue';
import SimpleList from '../components/SimpleList.vue';
import GreyBarWithTitleAndValue from '../components/microcomponents/GreyBarWithTitleAndValue.vue';
import ProspectRouteExpandableTable from '../components/Tables/ProspectRouteExpandableTable.vue';

export default {
  name: 'ProspectShow',
  components: {
    ProspectRouteExpandableTable,
    GoogleMapMarkers,
    SimpleList,
    GreyBarWithTitleAndValue,
  },
  data: () => ({
    prospect: {
      name: '',
      fullName: '',
      id: null,
      startDate: '',
      endDate: '',
      airportsIata: '',
      airlineId: null,
      recordId: null,
    },

    title: '',

    prospectHeadBars: [
      { title: 'Number of Destinations', value: null },
      { title: 'Number of Flights Month', value: null },
      { title: 'Number of POI\'s (experiences)', value: null },
      { title: 'Number of Reels', value: null },
    ],
    prospectRoutes: [],

    routeMapCategories: [],

    totalGeotags: 0,

    geotagsTotal: [],
    prospectContent: {
      poisTotalAmount: 0,
      videosTotalAmount: 0,
      playlistRating: [],
      providerRating: [],
      hashtagRating: [],
      hashtagGeotagRating: [],
      allVideoDuration: false,
      commonVideoDuration: false,
      reviewsTotalAmount: 0,
      poiHashtagsTotalAmount: 0,
      geotagHashtagsTotalAmount: 0,
    },
  }),

  created() {
    this.prospect.id = this.$route.params.id;
    this.$requestHelpers
      .get(`api/admin/prospect/${this.prospect.id}`)
      .then((response) => {
        this.prospect.name = response.data.result.name;
        this.title = response.data.result.name;
        this.prospect.fullName = response.data.result.full_name;
      });

    this.getRequestedGeotagsPois();
  },

  methods: {
    getRequestedGeotagsPois() {
      this.$requestHelpers
        .get(`api/admin/prospect/getStatistics/${this.prospect.id}`)
        .then((response) => {
          this.geotagsTotal = response.data.result.geotags_total;
          this.prospectContent.poisTotalAmount = response.data.result.pois_amount;
          this.prospectContent.videosTotalAmount = response.data.result.videos_amount;
          this.prospectContent.playlistRating = response.data.result.top_playlists
            .filter((el) => el.value > 0);
          this.prospectContent.providerRating = response.data.result.top_providers
            .filter((el) => el.value > 0);
          this.prospectContent.hashtagRating = response.data.result.top_hashtags
            .filter((el) => el.value > 0);
          this.prospectContent.hashtagGeotagRating = response.data.result.top_hashtags_geotags
            .filter((el) => el.value > 0);
          this.prospectContent.allVideoDuration = response.data.result.all_video_duration;
          this.prospectContent.commonVideoDuration = response.data.result.common_video_duration;
          this.routeMapCategories = response.data.result.destinations_rating;

          this.prospectContent
            .reviewsTotalAmount = response.data.result.total_provider_reviews_amount;
          this.prospectContent
            .poiHashtagsTotalAmount = response.data.result.total_poi_hashtag_amount;
          this.prospectContent
            .geotagHashtagsTotalAmount = response.data.result.total_geotag_hashtag_amount;

          this.prospectRoutes = response.data.result.routes;

          this.prospectHeadBars[0].value = [...new Set(this.prospectRoutes
            .filter((el) => el.pn_ids.length))].length;
          this.prospectHeadBars[1].value = this.prospectRoutes
            .reduce((accum, el) => accum + el.route_flights_amount, 0);
          this.prospectHeadBars[2].value = this.prospectContent.poisTotalAmount;
          this.prospectHeadBars[3].value = this.prospectContent.videosTotalAmount;
        });
    },
  },

  computed: {
    isGeotagRoutemapDestination() {
      return (geotagId) => this.prospectRoutes.find(
        (el) => el.tb_ids.includes(geotagId),
      ) !== undefined;
    },

    geotagsOnMap() {
      const selectedRoutes = this.prospectRoutes
        .filter((el) => el.is_selected);
      const geotagIdsInSelectedRoutes = [...new Set(selectedRoutes.map((el) => el.tb_ids).flat())];
      return this.geotagsTotal
        .filter((el) => geotagIdsInSelectedRoutes.includes(el.id));
    },
  },
};
</script>
